document.addEventListener('DOMContentLoaded', function () {
    const addToCartForm = document.querySelector('[data-type="add-to-cart-form"]');
    const popupBundleModal = document.querySelectorAll('.product-bundle-popup-modal');
    const priceContainer = document.querySelector('.product__info-wrapper .price__container');
    const priceItemRegular = priceContainer.querySelector('.price__regular .price-item--regular');
    const priceItemSaleRegular = priceContainer.querySelector('.price__sale .price-item--regular');
    const priceItemSale = priceContainer.querySelector('.price__sale .price-item--sale');
    const defaultProdPrice= document.querySelector('.price__sale .price-item--sale')?.textContent?.trim();

    const bundleSelects = document.querySelectorAll('.marlenespetshop-product-bundle-custom-variant-options');
    if (bundleSelects.length === 0) return;

    function getInputField(fieldName) {
        return addToCartForm.querySelector('input[name="'+fieldName+'"]');
    }

    function findVariantIdField() {
        let variantField = getInputField('id');
        if (!variantField) {
            variantField = addToCartForm.querySelector('select[name="id"]');
        }
        if (!variantField) {
            variantField = addToCartForm.querySelector('[name="id"]');
        }
        return variantField;
    }

    function updateProductPrice(bundlePrice, bundleComparePrice) {
        if (bundleComparePrice) {
            // If there's a compare price, show both
            priceItemSale.textContent = bundlePrice;
            priceItemSaleRegular.textContent = bundleComparePrice;
            priceItemSale.style.display = 'block';
            priceItemSaleRegular.style.display = 'block';
            return;
        }

        if (!bundleComparePrice && bundlePrice) {
            // If no compare price, just show regular price
            priceItemSale.textContent = bundlePrice;
            priceItemSale.style.display = 'block';
            return;
        }

        // If no sale price, just show regular price
        if (priceItemRegular) {
            priceItemRegular.textContent = defaultProdPrice;
        }
    }

    function resetSelectedVariant() {
        bundleSelects.forEach(function (bundleSelect) {
            bundleSelect.classList.remove('selected');
        });
    }

    function updateSelectedVariant(option) {
        const isCurrentlySelected = option?.classList?.contains('selected');
        if (isCurrentlySelected) return;

        // Reset all variants
        resetSelectedVariant();

        // Set the selected variant
        option.classList.add('selected');

        const productIdInput = getInputField('product-id');
        const variantIdInput = findVariantIdField();
        variantIdInput.value = option.dataset.variantId;
        productIdInput.value = option.dataset.productId;

        // Trigger the change event for the form
        variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
        productIdInput.dispatchEvent(new Event('change', { bubbles: true }));

        updateProductPrice(option.dataset.bundleProductPrice, option.dataset.bundleComparePrice);
    }

    bundleSelects.forEach(function (bundleItem, key) {
        if (key === 0) {
            // Set the first bundle as pre-selected
            updateSelectedVariant(bundleItem);
        }
        bundleItem.addEventListener('click', function (e) {
            updateSelectedVariant(this);
        });
    });

    popupBundleModal.forEach(function (modal) {
        modal.querySelector('.auto-select-btn').addEventListener('click', function (e) {
            //updateSelectedVariant(document.querySelector('[data-variant-id="'+this.dataset.autoSelectVariantId+'"]'));
            const closeBtn = modal.querySelector('.product-popup-modal__toggle');
            if (closeBtn) closeBtn.click();
        })
    })
});
